import environment from '@department-of-veterans-affairs/platform-utilities/environment';
/* eslint-disable camelcase */

export const UPLOAD_DESTINATION_KEYS = {
  BENEFITS_CLAIMS: 'benefits_claims',
};

const ALLOWED_DESTINATIONS = {
  [UPLOAD_DESTINATION_KEYS.BENEFITS_CLAIMS]: {
    endpoint: ({ claimId }) =>
      `${environment.API_URL}/v0/benefits_claims/${claimId}/benefits_documents`,
    // API contracts use snake_case keys in multipart params.

    buildUploadParams: ({
      trackedItemId,
      isFirstParty,
      fileMeta,
      uploadMetadata,
    }) => ({
      tracked_item_ids: JSON.stringify([trackedItemId]),
      is_first_party: isFirstParty,
      document_type: fileMeta?.docType?.value,
      password: fileMeta?.password?.value,
      provider: uploadMetadata?.provider,
      // The shared applicant id is the correlation value. The backend resolves the
      // applicant name it stores from this, so the name is deliberately not sent.
      // fileMeta.applicants still carries the name for the local success alert.
      applicant_id: fileMeta?.applicantId ?? undefined,
    }),
  },
};

const DEFAULT_DESTINATION_KEY = UPLOAD_DESTINATION_KEYS.BENEFITS_CLAIMS;

function compactObject(obj) {
  return Object.entries(obj).reduce((acc, [key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      acc[key] = value;
    }
    return acc;
  }, {});
}

export function resolveUploadDestinationConfig({
  claimId,
  trackedItemId,
  isFirstParty,
  uploadMetadata = {},
}) {
  const requestedKey = uploadMetadata?.uploadDestinationKey;
  const destinationKey = ALLOWED_DESTINATIONS[requestedKey]
    ? requestedKey
    : DEFAULT_DESTINATION_KEY;
  const destination = ALLOWED_DESTINATIONS[destinationKey];

  return {
    destinationKey,
    endpoint: destination.endpoint({ claimId, trackedItemId, uploadMetadata }),
    buildUploadParams: fileMeta =>
      compactObject(
        destination.buildUploadParams({
          claimId,
          trackedItemId,
          isFirstParty,
          uploadMetadata,
          fileMeta,
        }),
      ),
  };
}
/* eslint-enable camelcase */
